import React, { useContext } from "react";
import { FieldRenderProps } from "react-final-form";
import { useTranslation } from "react-i18next";

import { Input } from "reactstrap";
import { InputType } from 'reactstrap/lib/Input'
import { translationHookOptions } from "../../app/localization/localization";
import { RootStore, RootStoreContext } from "../../app/stores/rootStore";


interface IProps {
  errorfileUploaded: string[],
}
const UploadedFileErrors: React.FC<IProps> = ({
  errorfileUploaded
}) => {
  const rootStore = useContext(RootStoreContext);
  const [t] = useTranslation(["features"], translationHookOptions);
const {folderSizeFull}= rootStore.presentationStore;

  return (
 <>
<div>
  { errorfileUploaded && errorfileUploaded.length>0 && (<>
    <div>
    {errorfileUploaded.map((x: string, index: any) => (<>
      <li key={index} style={{color:"red"}}>{x}</li>
    </>))}
    </div>

    <div style={{marginTop:"3%"}}>
     {folderSizeFull ? (t("body_modal_errorsfilesUploaded_diskuser")) : (t("body_modal_errorsfilesUploaded"))} 

    </div>
    </>)}
    

</div>
 
 </>
  );
};

export default UploadedFileErrors;
